// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.certification-item {
    margin-bottom: 25px;
}
.certification-item h3{
    margin-bottom: 0 !important;
    font-weight: 500;
    font-size: 1.3rem;
}`, "",{"version":3,"sources":["webpack://./src/v3/legacy_components/UI_V2_Components/shared/certification/Certification.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;AACvB;AACA;IACI,2BAA2B;IAC3B,gBAAgB;IAChB,iBAAiB;AACrB","sourcesContent":[".certification-item {\n    margin-bottom: 25px;\n}\n.certification-item h3{\n    margin-bottom: 0 !important;\n    font-weight: 500;\n    font-size: 1.3rem;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
